import React from "react";
import { IGenericHistoryType } from "./GameHistoryTypes";
import { ILanguageType } from "./GlobalTypes";

//Game Statistics
export interface IGameStatisticsProps {
	filters: string[];
	history: IGenericHistoryType[];

	langdata: ILanguageType;
}

type IFiltrate = (history: IGenericHistoryType[], filter: string) => void;

export class IGameStatisticsClass extends React.Component {
	props: IGameStatisticsProps;

	statisticsArray: IStatisticsArray;
	filtrate: IFiltrate;
}

export interface IStatisticsArray {
	top: JSX.Element[];
	bottom: JSX.Element[];
}
